<template>
    <div class="az-form-content">
        <lotes-itens @onUploadCompletoPlanilhaLotes="importarPlanilha"
                     @onUploadCompletoTextoLotes="importarTexto"
                     @onConfirmarRemoverLotes="removerLotes"
                     :editando="false"
                     :possui-proposta="possuiProposta"
                     :publicado="this.$store.state.licitacao.publicado"
        ></lotes-itens>
    </div>
</template>

<script>
import {mapActions, mapMutations} from 'vuex'
import {actionTypes, exceptions, mutationTypes} from '@/commons/constants'
import LotesItens from '../commons/LotesItens.vue'
import store from "@/commons/store";

export default {
        name: 'CredenciamentoAtualizacaoLotesItens',
        components: {LotesItens},
        data() {
            return {
                possuiProposta: undefined,
                editando: false,
                licitacaoId: undefined
            }
        },
        beforeRouteLeave(to, from, next) {
            this.habilitarLoadingGlobal()
            next()
        },
        created() {
            this.desabilitarLoadingGlobal()
        },
        async mounted() {
            this.setLicitacaoId(this.$route.params.id)
            this.setEditando(this.$route.query.edicao)
            await this.buscarLotes()
            await this.possuiPropostaEnviada()
        },
        methods: {
            async buscarLotes() {
                this.habilitarLoadingGlobal()
                this.setMensagemLoading('Atualizando listagem de lotes...')
                await this.buscarLotesItemPorLicitacao(this.licitacaoId)
                this.desabilitarLoadingGlobal()
            },
            async importarPlanilha(newVal) {
                try {
                    const ultima = newVal.length - 1
                    const paramsLotes = {
                        licitacaoId: this.licitacaoId,
                        arquivo: newVal[ultima]
                    }
                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Importando lotes...')
                    await this.importarLotesItemPlanilha(paramsLotes)
                    this.mostrarNotificacaoSucessoDefault()
                    this.setMensagemLoading('Sincronizando credenciamento...')
                    await this.buscarLicitacao(this.licitacaoId)
                    this.desabilitarLoadingGlobal()
                    this.$store.commit('SET_UPLOADED_FILES', [])
                } catch (err) {
                    const exception = err.response ? exceptions[err.response.data.exception] : undefined
                    if (exception && exception.ignorarNotificacaoDefault) {
                        this.mostrarMensagemErro(err.response.data.message)
                    }
                    this.desabilitarLoadingGlobal()
                }
            },
            async importarTexto(newVal, modeloImportacao) {
                try {
                    const ultima = newVal.length - 1
                    const paramsLotes = {
                        licitacaoId: this.licitacaoId,
                        arquivo: newVal[ultima],
                        nomeModelo: modeloImportacao
                    }
                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Importando lotes...')
                    await this.importarLotesItemTxt(paramsLotes)
                    this.mostrarNotificacaoSucessoDefault()
                    this.setMensagemLoading('Sincronizando credenciamento...')
                    await this.buscarLicitacao(this.licitacaoId)
                    this.desabilitarLoadingGlobal()
                    this.$store.commit('SET_UPLOADED_FILES', [])
                } catch (err) {
                    const exception = err.response ? exceptions[err.response.data.exception] : undefined
                    if (exception && exception.ignorarNotificacaoDefault) {
                        this.mostrarMensagemErro(err.response.data.message)
                    }
                    this.desabilitarLoadingGlobal()
                }
            },
            async removerLotes() {
                try {
                    const paramsLotes = {
                        licitacaoId: this.licitacaoId
                    }
                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Removendo lotes...')
                    await this.removerLotesItem(paramsLotes)
                    this.mostrarNotificacaoSucessoDefault()
                    await this.buscarLotesItemPorLicitacao(this.licitacaoId)
                    this.desabilitarLoadingGlobal()
                } catch (err) {
                    this.desabilitarLoadingGlobal()
                }
            },
            async possuiPropostaEnviada() {
              this.possuiProposta = await this.existePropostaEnviada(this.licitacaoId)
            },
            setEditando(editando) {
                this.editando = !!(editando && store.state.perfilCredenciamentoEdicao.value)
            },
            setLicitacaoId(licitacaoId) {
                this.licitacaoId = licitacaoId
            },
            ...mapActions([
                actionTypes.BUSCAR_LICITACAO,
                actionTypes.BUSCAR_LOTES_ITEM_POR_LICITACAO,
                actionTypes.IMPORTAR_LOTES_ITEM_PLANILHA,
                actionTypes.IMPORTAR_LOTES_ITEM_TXT,
                actionTypes.REMOVER_LOTES_ITEM,
                actionTypes.EXISTE_PROPOSTA_ENVIADA
            ]),
            ...mapMutations([
                mutationTypes.MOSTRAR_MENSAGEM_ERRO
            ])
        }
    }
</script>
